/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import { LogosPartnersGroup } from '../LogosPartnersGroup';
import { LogosSocialMediaPlatforms } from '../LogosSocialMediaPlatforms';

import './style.css';

export const Footer = ({
    className,
    logosPartnersGroupLogoPartnerBundesministerium = '/img/BMBFSFJ_gefoerdert_vom_deutsch_Web_c.svg',
}) => {
    return (
        <div className={`footer ${className}`}>
            <div className={`footer-container`}>
                <div className="footer-content">
                    <div className="footer-column">
                        <img
                            className="footer-logo"
                            alt="Tübingen University Logo"
                            src="/img/universitaettuebingen-wortbildmarke-white-tu-cede-1.png"
                        />

                        <div className="footer-links-container">
                            <LogosPartnersGroup
                                breakpoint="desktop"
                                className="footer-section partner-logos"
                                color="white"
                                logoPartnerBundesministerium={
                                    logosPartnersGroupLogoPartnerBundesministerium
                                }
                            />

                            <div className="logos-partners-group color-5-white breakpoint-0-desktop footer-section">
                                <div>
                                    <span style={{ color: 'white' }}>
                                        © 2024, Tübingen Center for Digital
                                        Education.
                                    </span>
                                </div>

                                <div>
                                    <a
                                        style={{ color: 'white' }}
                                        href="/impressum/"
                                        className="ut-link ut-nav__link"
                                    >
                                        Impressum
                                    </a>
                                </div>
                                <div>
                                    <a
                                        style={{ color: 'white' }}
                                        href="/datenschutz/"
                                        className="ut-link ut-nav__link"
                                    >
                                        Datenschutzerklärung
                                    </a>
                                </div>
                                <div>
                                    <a
                                        style={{ color: 'white' }}
                                        href="/impressum/"
                                        className="ut-link ut-nav__link"
                                        onClick={() => {
                                            //navigate("/impressum");
                                        }}
                                    >
                                        Barrierefreiheit
                                    </a>
                                </div>

                                <LogosSocialMediaPlatforms
                                    breakpoint="desktop"
                                    className="socials"
                                    color="white"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Footer.propTypes = {
    property1: PropTypes.oneOf(['desktop', 'mobile']),
    logosPartnersGroupLogoPartnerBundesministerium: PropTypes.string,
};
